
import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {  } from 'epi-components/dist/types';

@Directive({
	standalone: false,
	selector: '[qeEpiControl]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => EpiControlDirective),
			multi: true,
		},
	],
})
export class EpiControlDirective implements ControlValueAccessor {

	public disabled: boolean = false;
	public checked: boolean = false;

	constructor(
		private readonly el: ElementRef<HTMLEpiCheckboxElement>,
		private readonly renderer: Renderer2,
	) { }

	@HostListener('blur')
	public handleTouch(): void {
		this.onTouched();
	}
	@HostListener('epiCheckChanged')
	public handleChange(): void {
		this.onChanged(this.el.nativeElement.checked);
	}

	/* eslint-disable */
	public onChanged: any = () => { };
	public onTouched: any = () => { };
	/* eslint-enable */

	/** Passes the value to the custom control */
	writeValue(isChecked: boolean): void {
		this.renderer.setProperty(
			this.el.nativeElement,
			'checked',
			isChecked,
		);
	}

	/** Handles the change of the control's value */
	registerOnChange(fn: () => void): void {
		this.onChanged = fn;
	}

	/** Handles when the control has been interacted with */
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	// setChecked (isChecked: boolean): void {
	// 	if (!this.disabled) {
	// 		this.checked = isChecked;
	// 		this.onChanged(isChecked);
	// 		this.onTouched();
	// 	}
	// }
	setDisabledState(isDisabled: boolean): void {
		this.renderer.setAttribute(
			this.el.nativeElement,
			'disabled',
			`${isDisabled}`,
		);
	}

}
